module.exports = jQuery.fn.slick;